// Shared constants and functions for analytics related services

// FullStory
export const FULLSTORY_MASK_CLASSNAME = 'fs-mask';
